@if (multiUserFormSetupService.visible()) {
    <multi-user-form-create-instance-dialog
        [multiUserFormDef]="multiUserFormSetupService.mufDefinition()"
        [patientId]="multiUserFormSetupService.patientId()"
        [episodeId]="multiUserFormSetupService.episodeId()"
        (onCancel)="multiUserFormSetupService.cancelMufInstance()"
        (onCreate)="multiUserFormSetupService.saveMufInstance($event)">
    </multi-user-form-create-instance-dialog>
}